import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_textarea_filled = _resolveComponent("v-textarea-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_PaymentModeWizard = _resolveComponent("PaymentModeWizard")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "12"
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "12",
                class: "py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_textarea_filled, {
                    label: "Détails du paiement",
                    "auto-grow": "",
                    "min-rows": "3",
                    modelValue: _ctx.company.invoiceTextPaymentDetails,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company.invoiceTextPaymentDetails) = $event))
                  }, {
                    "append-inner": _withCtx(() => [
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                            _createVNode(_component_v_btn_icon, {
                              icon: "$fa-redo-alt",
                              size: "small",
                              disabled: 
                                                _ctx.company.invoiceTextPaymentDetails ===
                                                _ctx.defaultPaymentDetails
                                            ,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (
                                                _ctx.company.invoiceTextPaymentDetails =
                                                    _ctx.defaultPaymentDetails
                                            ))
                            }, null, 8, ["disabled"])
                          ], 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[7] || (_cache[7] = _createElementVNode("span", null, "Remettre les valeurs par défauts", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "12",
                class: "py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_textarea_filled, {
                    label: "Mentions légales*",
                    "auto-grow": "",
                    "min-rows": "3",
                    modelValue: _ctx.company.invoiceTextLegalNotices,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.company.invoiceTextLegalNotices) = $event))
                  }, {
                    "append-inner": _withCtx(() => [
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                            _createVNode(_component_v_btn_icon, {
                              icon: "$fa-redo-alt",
                              size: "small",
                              disabled: 
                                                _ctx.company.invoiceTextLegalNotices === _ctx.defaultLegalForm
                                            ,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (
                                                _ctx.company.invoiceTextLegalNotices = _ctx.defaultLegalForm
                                            ))
                            }, null, 8, ["disabled"])
                          ], 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[8] || (_cache[8] = _createElementVNode("span", null, "Remettre les valeurs par défauts", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "12",
                class: "py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_textarea_filled, {
                    label: "Mode de paiement",
                    "auto-grow": "",
                    "min-rows": "3",
                    modelValue: _ctx.company.invoiceTextPaymentMode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.company.invoiceTextPaymentMode) = $event)),
                    "data-cy": "LegalForm-paymentMode"
                  }, {
                    "append-inner": _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _withDirectives(_createVNode(_component_v_btn_icon, {
                          icon: "$edit",
                          size: "small",
                          onClick: _ctx.openPaymentModeWizard,
                          "data-cy": "LegalForm-paymentMode-edit"
                        }, null, 8, ["onClick"]), [
                          [_directive_tooltip, 'Configurer le mode de paiement', "bottom"]
                        ]),
                        _withDirectives(_createVNode(_component_v_btn_icon, {
                          icon: "$fa-redo-alt",
                          size: "small",
                          disabled: !_ctx.company.invoiceTextPaymentMode,
                          onClick: _ctx.resetPaymentMode
                        }, null, 8, ["disabled", "onClick"]), [
                          [_directive_tooltip, 'Remettre les valeurs par défaut', "bottom"]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "d-flex align-end" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "12",
                class: "d-flex justify-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    "data-cy": "LegalForm-Engregistrer",
                    elevation: "0",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveInvoiceSettings())),
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_PaymentModeWizard, {
        modelValue: _ctx.isWizardDialogOpen,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isWizardDialogOpen) = $event)),
        companyId: _ctx.companyId,
        onPaymentModeSelected: _ctx.updatePaymentMode
      }, null, 8, ["modelValue", "companyId", "onPaymentModeSelected"])
    ]),
    _: 1
  }))
}